import { ActionsUnion, createAction } from "store/helper";

import {
  CRUDAction,
  IEntityDelete,
  IEntityDeleteSuccess,
  IEntityUpdate,
  RequestAction,
  createEntityActionNames,
  createEntityActions,
  createRequestTypes,
} from "../actions";

import { IContactForm, ISyncDeleteContactFormPayload } from "./interfaces";

export const ContactFormActionNames = {
  ...createEntityActionNames("CONTACT_FORM"),
  SYNC_DELETE: "ENTITIES/CONTACT_FORMS/SYNC_DELETE",
  UPDATE_DEFAULT: createRequestTypes("ENTITIES/CONTACT_FORM/UPDATE_DEFAULT"),
};

export const ContactFormActions = {
  ...createEntityActions<IContactForm>(ContactFormActionNames),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  delete: (payload: IEntityDelete & { skipToast?: boolean }) =>
    createAction(ContactFormActionNames[CRUDAction.DELETE][RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteSuccess: (payload: IEntityDeleteSuccess & { skipToast?: boolean }) =>
    createAction(ContactFormActionNames[CRUDAction.DELETE][RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateDefault: (payload: IEntityUpdate<IContactForm>) =>
    createAction(ContactFormActionNames.UPDATE_DEFAULT[RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateDefaultSuccess: () => createAction(ContactFormActionNames.UPDATE_DEFAULT[RequestAction.SUCCESS], {}),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateDefaultFailure: () => createAction(ContactFormActionNames.UPDATE_DEFAULT[RequestAction.FAILURE], {}),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  syncDelete: (payload: ISyncDeleteContactFormPayload) => createAction(ContactFormActionNames.SYNC_DELETE, payload),
};

export type ContactFormAction = ActionsUnion<typeof ContactFormActions>;
